import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";
import { onUpdateAvailable, applyUpdate } from "../lib/pwa";

/**
 * Non-blocking "new version available" toast. The service worker never
 * activates itself mid-session (PWA spec §9) — this component gives the
 * customer control over the reload so we don't nuke their cart/checkout
 * state.
 */
const UpdateToast = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => onUpdateAvailable(() => setVisible(true)), []);

    if (!visible) return null;

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="pwa-update-toast"
                    initial={{ y: 60, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 60, opacity: 0 }}
                    className="fixed left-3 right-3 bottom-3 z-40 mx-auto max-w-md
                               bg-[#1B995E] text-white rounded-2xl p-3 flex items-center gap-3"
                >
                    <Sparkles className="h-5 w-5 shrink-0" strokeWidth={2.5} />
                    <div className="flex-1 text-sm font-display font-bold">
                        New Coffeein7 version ready
                    </div>
                    <button
                        data-testid="pwa-update-btn"
                        onClick={applyUpdate}
                        className="rounded-full bg-white text-[#0f6b41] px-4 py-1.5 font-display font-bold text-sm active:scale-95"
                    >
                        Update
                    </button>
                    <button
                        onClick={() => setVisible(false)}
                        aria-label="Dismiss update"
                        className="text-white/70 text-xs font-bold hover:text-white"
                    >
                        Later
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default UpdateToast;
